import { create } from "zustand";

export type SummaryOfNextOrderForPicking = {
  id: string;
  number: string | null;
} | null;

export type AppBackgroundEffectsStore = {
  summaryOfNextOrderForPicking: SummaryOfNextOrderForPicking;
  // picking-service keeps returning the order being picked until it has processed the pack, and a
  // poll already in flight can land after it. Ignored until a poll returns anything else.
  lastPackedOrderId: string | null;
  hasOpenUrgentChecks: boolean;
  publicRestockingItemCount: number;
  hasUnClaimedCancelledOrder: boolean;
};

type AppBackgroundEffectsStoreWithMethods = AppBackgroundEffectsStore & {
  setAppBackgroundEffectsStore(state: Partial<AppBackgroundEffectsStore>): void;
  clearCurrentNextOrderId(orderId: string): void;
  markOrderPacked(orderId: string): void;
};

const initialState: AppBackgroundEffectsStore = {
  summaryOfNextOrderForPicking: null,
  lastPackedOrderId: null,
  hasOpenUrgentChecks: false,
  publicRestockingItemCount: 0,
  hasUnClaimedCancelledOrder: false,
};

export const useAppBackgroundEffectsStore = create<AppBackgroundEffectsStoreWithMethods>()(
  (set, get) => ({
    ...initialState,
    setAppBackgroundEffectsStore(state) {
      set(state);
    },
    clearCurrentNextOrderId(orderId) {
      const { summaryOfNextOrderForPicking } = get();
      if (summaryOfNextOrderForPicking?.id === orderId) {
        set({ summaryOfNextOrderForPicking: null });
      }
    },
    markOrderPacked(orderId) {
      set({ lastPackedOrderId: orderId });
      get().clearCurrentNextOrderId(orderId);
    },
  }),
);
